import React, { useContext, useEffect, useState } from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { ShieldPlus } from "lucide-react";
import axios from "axios";
import Loading from "./Loading";
import { AuthContext } from "../Contexts/AuthContext";
import Swal from "sweetalert2";
import { motion } from "framer-motion";

export default function Funcionarios() {
  const [colaboradores, setColaboradores] = useState([]);
  const [loading, setLoading] = useState(false);

  const { usuario } = useContext(AuthContext);

  async function mostrarColaboradores() {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("token"));

      const dados = await axios.get(
        "https://api-eyazs-production-8f74.up.railway.app/usuariosids",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (dados) setColaboradores(dados.data);
    } catch (erro) {
      console.log(erro);
    } finally {
      setLoading(false);
    }
  }

  async function habilitarColaborador(id) {
    try {
      const resultado = await Swal.fire({
        title: "Tens certeza?",
        text: "Este Colaborador será Conectado a Internet!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sim, Conectar!",
        cancelButtonText: "Cancelar",
      });

      if (resultado.isConfirmed) {
        const token = JSON.parse(localStorage.getItem("token"));

        await axios.get(
          `https://api-eyazs-production-8f74.up.railway.app/conectar/${id}`
        );

        await axios.put(
          `https://api-eyazs-production-8f74.up.railway.app/usuario/${id}`,
          { profile: "PLANO-6Mbps" },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        await Swal.fire({
          title: "Online!",
          text: "Colaborador Conectado com sucesso!",
          icon: "success",
        });
      }
    } catch (erro) {
      console.log(erro);
    }
  }

  useEffect(() => {
    mostrarColaboradores();
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Navbar */}
      <div className="bg-blue-500 sticky top-0 z-10">
        <NavBar />
      </div>

      {/* Conteúdo animado */}
      {loading ? (
        <Loading />
      ) : (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="flex justify-center px-2 sm:px-4 py-6"
        >
          <div className="w-full max-w-7xl border rounded-md shadow-md">
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="border px-3 py-2 text-center">
                      Ordem
                    </th>
                    <th className="border px-3 py-2 text-center">
                      Nome
                    </th>
                    <th className="border px-3 py-2 text-center">
                      Estado
                    </th>
                    {(usuario.tipoUsuario !== "admin" ||
                      usuario.name === "fernando") && (
                      <th className="border px-3 py-2 text-center">
                        Habilitar
                      </th>
                    )}
                  </tr>
                </thead>

                <motion.tbody
                  initial="hidden"
                  animate="visible"
                  variants={{
                    visible: {
                      transition: {
                        staggerChildren: 0.05,
                      },
                    },
                  }}
                >
                  {colaboradores
                    .sort((a, b) =>
                      a.name.localeCompare(b.name)
                    )
                    .map((colaborador, i) => (
                      <motion.tr
                        key={i}
                        variants={{
                          hidden: { opacity: 0, y: 10 },
                          visible: { opacity: 1, y: 0 },
                        }}
                        className="hover:bg-gray-100"
                      >
                        <td className="border px-3 py-2 text-center">
                          {i + 1}
                        </td>

                        <td className="border px-3 py-2 text-center">
                          {colaborador.name}
                        </td>

                        <td className="border px-3 py-2 text-center">
                          {colaborador.disabled === "false"
                            ? "Activo"
                            : "Desativado"}
                        </td>

                        {(usuario.tipoUsuario !== "admin" ||
                          usuario.name === "fernando") && (
                          <td className="border px-3 py-2 text-center">
                            <motion.div
                              whileHover={{ scale: 1.2 }}
                              whileTap={{ scale: 0.9 }}
                            >
                              <ShieldPlus
                                className="mx-auto h-6 w-6 cursor-pointer hover:text-blue-500"
                                onClick={() =>
                                  habilitarColaborador(
                                    colaborador.idUsuario
                                  )
                                }
                              />
                            </motion.div>
                          </td>
                        )}
                      </motion.tr>
                    ))}
                </motion.tbody>
              </table>
            </div>
          </div>
        </motion.div>
      )}

      {/* Footer */}
      <div className="bg-blue-500 mt-auto">
        <Footer />
      </div>
    </div>
  );
}
